<template>
  <button 
    @click="click"
    :class="{'selected': selected}">
    <slot>H</slot>
  </button>
</template>

<script>
export default {
  props: {
    selected: Boolean,
  },

  methods: {
    click() {
      this.$emit("update:showPanel");
    }
  }
}
</script>

<style scoped>
button {
  flex-grow: 1;
  display: inline-block;
  cursor: pointer;
  background: #001e44;
  color: #fff;
  border: none;
  text-transform: uppercase;
}

button:active, .selected {
  background: #003577;
}
</style>
